<ion-header>
  <ion-toolbar>
    @if(state.isBigScreen){
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }@else{
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
    <ion-title>
      @switch (report.type) { @case (ConstructionDayReportType.$0) {
      {{ "reports.daily" | translate }} } @case (ConstructionDayReportType.$1) {
      {{ "reports.trip" | translate }} } @case (ConstructionDayReportType.$2) {
      {{ "reports.work" | translate }} } @default {
      {{ "reports.basicReport" | translate }} } }{{
        this.toolService.formatDt(report?.date)
      }}</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-content>
  @if (sameDayReports.length > 1) {
  <div class="same-day-reports">
    {{ "reports.sameDay" | translate : { count: sameDayReports.length } }}
  </div>
  } @if (sameDayReports.length > 1) {
  <ion-segment
    style="width: 100%"
    [value]="paramId"
    (ionChange)="segmentChanged($event)"
  >
    @for (rp of sameDayReports; track rp) {
    <ion-segment-button [value]="rp.id">
      <ion-label>{{
        state.getUserDisplayNameAsync(rp.responsibleWorker) | async
      }}</ion-label>
    </ion-segment-button>
    }
  </ion-segment>
  }
  <div class="container">
    <div>
      <div class="stretch">
        @if(report.type === ConstructionDayReportType.$0){
        <ion-chip color="primary">
          <ion-icon name="clipboard-outline"></ion-icon>
          <ion-label color="dark">{{ "reports.daily" | translate }}</ion-label>
        </ion-chip>

        } @if(report.type === ConstructionDayReportType.$1){
        <ion-chip color="primary">
          <ion-icon name="speedometer-outline"></ion-icon>
          <ion-label color="dark">{{ "reports.trip" | translate }}</ion-label>
        </ion-chip>

        } @if(report.type === ConstructionDayReportType.$2){
        <ion-chip color="primary">
          <ion-icon name="time-outline"></ion-icon>
          <ion-label color="dark">{{ "reports.work" | translate }}</ion-label>
        </ion-chip>

        } @if(report.isDraft){
        <ion-chip color="primary">
          <ion-icon name="document-text-outline"></ion-icon>
          <ion-label color="dark">{{ "reports.draft" | translate }}</ion-label>
        </ion-chip>
        } @if(!report.isDraft && report.approvedBy == null){
        <ion-chip color="warning">
          <ion-icon color="warning" name="checkmark-circle-outline"></ion-icon>
          <ion-label color="dark">{{ "status.pending" | translate }}</ion-label>
        </ion-chip>
        } @if(report.approvedBy != null){
        <ion-chip color="success">
          <ion-icon color="success" name="checkmark-circle-outline"></ion-icon>
          <ion-label color="dark">{{
            "status.confirmed" | translate
          }}</ion-label>
        </ion-chip>
        }
      </div>

      @if (state.userHasMinType(3)) {
      <div class="stretch">
        <div>{{ "common.id" | translate }}:</div>
        <div>
          {{ report.id }}
        </div>
      </div>
      }
      <div class="stretch">
        <div>{{ "common.constructionSite" | translate }}:</div>
        <div>
          {{ state.getConstructionSiteName(report.constructionSite) }}
        </div>
      </div>
      <div class="stretch">
        <div>
          @if(report.type == ConstructionDayReportType.$1){
          {{ "user.driver" | translate }}}@else{
          {{ "user.responsible" | translate }}}:
        </div>
        <div>
          {{ state.getUserDisplayNameAsync(report.responsibleWorker) | async }}
        </div>
      </div>
      @if(report.type == ConstructionDayReportType.$0){
      <div class="stretch">
        <div>{{ "reports.weather" | translate }}:</div>
        <div>
          @if(report.weather?.length > 0){
          <span>{{ report.weather.join(", ") }} / </span>
          }
          {{ report.temperatureInCelsius }}°C
        </div>
      </div>
      } @if (report.electricityUsedInKWH > 0) {
      <div class="stretch">
        <div>{{ "reports.electricity" | translate }}:</div>
        <div>{{ report.electricityUsedInKWH }} kWh</div>
      </div>
      } @if (report.waterUsedInCubicMeters) {
      <div class="stretch">
        <div>{{ "reports.water" | translate }}:</div>
        <div>{{ report.waterUsedInCubicMeters }} m³</div>
      </div>
      } @if (report.workers.length > 0) {
      <div class="stretch">
        <div>{{ "reports.workers" | translate }}:</div>
        <div>{{ report.workers.length }}</div>
      </div>
      } @if (report.lastModifiedUtc) {
      <div class="stretch">
        <div>{{ "common.lastModified" | translate }}:</div>
        <div>
          {{ state.getUserDisplayNameAsync(report.lastModifiedBy) | async }} ({{
            this.toolService.formatDt(report.lastModifiedUtc)
          }}, {{ this.toolService.formatTime(report.lastModifiedUtc, true) }})
        </div>
      </div>
      }
      <div class="divider"></div>
      @if (report.workingTimes) {
      <div>
        <b
          >{{ "hours.workTime" | translate }} ({{
            this.toolService.calculateHours(this.report.workingTimes)
          }})</b
        >
      </div>
      } @if (report.workingTimes) {
      <div>
        @for (time of report.workingTimes; track time) {
        <div>
          {{
            "reports.timeRange"
              | translate
                : {
                    start: this.toolService.formatTime(time.start),
                    end: this.toolService.formatTime(time.end)
                  }
          }}
        </div>
        }
      </div>
      } @for (worker of report.workers; track worker) {
      <div>
        <b
          >{{ this.state.getUserDisplayNameAsync(worker) | async }} ({{
            this.toolService.calculateHours(
              this.report.workerTimeEntries[worker]
            )
          }})</b
        >
        @for (time of report.workerTimeEntries[worker]; track time) {
        <div>
          {{
            "reports.timeRange"
              | translate
                : {
                    start: this.toolService.formatTime(time.start),
                    end: this.toolService.formatTime(time.end)
                  }
          }}
        </div>
        }
      </div>
      }
      <div class="divider"></div>
      @if (report.report) {
      <div>
        <div>
          <b>{{ "reports.results" | translate }}</b>
        </div>
        <div class="multiline">{{ report.report }}</div>
      </div>
      } @if (report.rapport) {
      <div>
        <div>
          <b>{{ "reports.rapport" | translate }}</b>
        </div>
        <div>{{ report.rapport }}</div>
      </div>
      } @if (report.difficulties) {
      <div>
        <div>
          <b>{{ "reports.difficulties" | translate }}</b>
        </div>
        <div>{{ report.difficulties }}</div>
      </div>
      } @if (report.specialIncidents) {
      <div>
        <div>
          <b>{{ "reports.incidents" | translate }}</b>
        </div>
        <div>{{ report.specialIncidents }}</div>
      </div>
      } @if(report.machineUsages?.length > 0){
      <div class="divider"></div>

      <div class="custom-table">
        <div class="row header">
          <div class="col">{{ "reports.machineUsage" | translate }}</div>
          <div class="col">{{ "reports.duration" | translate }}</div>
          <div class="col grow">{{ "common.description" | translate }}</div>
        </div>

        @for(machine of report.machineUsages; track machine.id){
        <div class="row">
          <div class="col">
            {{ state.getMachineNameAsync(machine.id) | async }}
          </div>
          <div class="col">
            {{ machine.usageInHours }}
            @if(machine.usageInHours === 1){
            {{ "reports.hour" | translate }} }@else{
            {{ "reports.hours" | translate }} }
          </div>
          <div class="col grow">{{ machine.description }}</div>
        </div>
        }
      </div>
      } @if(report.rentalMachines?.length > 0){
      <div class="divider"></div>

      <div class="custom-table">
        <div class="row header">
          <div class="col">{{ "reports.rentalMachines" | translate }}</div>
          <div class="col">{{ "reports.duration" | translate }}</div>
          <div class="col grow">{{ "common.description" | translate }}</div>
        </div>

        @for(machine of report.rentalMachines; track machine){
        <div class="row">
          <div class="col">
            {{ machine.name }}
          </div>
          <div class="col">
            {{ machine.usageInHours }}
            @if(machine.usageInHours === 1){
            {{ "reports.hour" | translate }} }@else{
            {{ "reports.hours" | translate }} }
          </div>
          <div class="col grow">{{ machine.description }}</div>
        </div>
        }
      </div>
      } @if(report.materialConsumption?.length > 0){
      <div class="divider"></div>

      <div class="custom-table">
        <div class="row header">
          <div class="col">{{ "reports.material" | translate }}</div>
          <div class="col">{{ "reports.quantity" | translate }}</div>
          <div class="col grow">{{ "reports.supplier" | translate }}</div>
        </div>

        @for(material of report.materialConsumption; track material){
        <div class="row">
          <div class="col">
            {{ material.name }}
          </div>
          <div class="col">{{ material.amount }} {{ material.unit }}</div>
          <div class="col grow">{{ material.supplier }}</div>
        </div>
        }
      </div>
      } @if(attachedImageNodeItems.length > 0){
      <div class="divider"></div>

      <b>{{ "common.images" | translate }}:</b>

      <div class="preview-container">
        @for (preview of previews; track preview) {
        <div class="preview-card" (click)="openFile(preview.id)">
          <!-- Lädt -->
          @if (preview.loading) {
          <div class="loading-container">
            <ion-spinner name="crescent"></ion-spinner>
          </div>
          }
          <!-- Fehler -->
          @if (!preview.loading && preview.hasError) {
          <div class="error-container">
            <ion-icon name="image-outline" color="medium"> </ion-icon>
          </div>
          }
          <!-- Bild -->
          @if (!preview.loading && !preview.hasError) {
          <img [src]="preview.imageUrl" [alt]="'common.preview' | translate" />
          }
        </div>
        }
      </div>
      } @if(attachedDocumentNodeItems.length > 0){
      <div class="divider"></div>

      <b>{{ "common.documents" | translate }}:</b>
      @for(doc of attachedDocumentNodeItems; track doc.id){
      <div class="base-padding">
        <ion-button
          fill="outline"
          (click)="openFile(doc.id)"
          style="width: 100%"
        >
          <ion-icon slot="start" [name]="state.getIcon(doc)"></ion-icon>
          {{ doc.displayName }}
        </ion-button>
      </div>
      } } @if (report.errors?.length > 0) {
      <div class="divider"></div>
      <div>
        {{ "reports.errorList" | translate }}:
        <ul>
          @for (err of report.errors; track err) {
          <li>
            {{ err }}
          </li>
          }
        </ul>
      </div>
      }
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="footer-buttons">
      @if ( report.errors?.length > 0 && report.approvedBy == null &&
      state.userHasMinType(1) ) {
      <ion-button (click)="fixErrors()">{{
        "common.fixErrors" | translate
      }}</ion-button>
      }
      <ion-button (click)="viewReport()">{{
        "common.show" | translate
      }}</ion-button>

      @if( state.userHasMinType(2) || (report.approvedBy == null &&
      state.userHasMinType(1)) || (report.isDraft && state.userName ==
      report.responsibleWorker) || (report.isDraft && state.userName ==
      report.responsibleWorker) || (report.approvedBy == null && isFreshReport)
      ){
      <ion-button (click)="editReport()">{{
        "common.edit" | translate
      }}</ion-button
      >} @if ( state.userHasMinType(1) && report.approvedBy == null &&
      !report.isDraft && report.errors?.length == 0 ) {
      <ion-button color="success" (click)="approveReport()">{{
        "common.confirm" | translate
      }}</ion-button>
      } @if(state.userHasMinType(2) || (report.isDraft &&
      (state.userHasMinType(1) || state.userName == report.responsibleWorker
      ))){
      <ion-button color="danger" (click)="deleteReport()">{{
        "common.delete" | translate
      }}</ion-button
      >}
    </div>
  </ion-toolbar>
</ion-footer>
